import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    settings: {
      darkModeOn: false
    },
    activeSections: {
      home: false,
      about: false,
      services: false,
      partners: false,
      contact: false
    },
    platform: { // Initialized in App.vue on load
      name: null,
      isMobile: null,
      isDesktop: null,
      windowWidth: null,
      scrollPosition: 'home'
    },
    nav: {
      links: [],
      destinations: {},
      isOpen: false,
    },
    loaded: false
  },
  mutations: {
    //syncronous
    loadSections(state, payload) {
      state.nav.links = payload;
    },
    tellPlatform(state, payload) {
      if (payload == 'mobile') {
        state.platform.isMobile = true;
        state.platform.isDesktop = false;
        state.platform.name = payload;
      } else if (payload == 'desktop') {
        state.platform.isMobile = false;
        state.platform.isDesktop = true;
        state.platform.name = payload;
        state.nav.isOpen = false;
      } else {
        console.error('Platform size not accepted. Must be mobile or desktop.');
      }
    },
    toggleActiveSection(state, payload) {
      let pl = payload;
      let nameCaseChange = pl.name.toLowerCase();
      state.activeSections[nameCaseChange] = payload.isActive;
    },
    toggleNav(state) {
      if (state.nav.isOpen == false) {
        state.nav.isOpen = true;
      } else if (state.nav.isOpen) {
        state.nav.isOpen = false;
      }
    },
    setDark(state, payload) {
      if (typeof payload !== 'boolean') {
        console.error('setDark must be a boolean');
      } else {
        state.settings.darkModeOn = payload;
      }
    }
  },
  actions: {
    //asyncronous
  },
  getters: {
    
  },
  modules: {
  }
})
